<template>
  <div class="goods">
	<div class="contentBox">
		<v-head :title="title"></v-head>
		<div class="means">
			<div class="artBox">
				<template v-if="userInfo.gender==2">
					<img src="../../assets/images/gender2.jpg" class="portrait" />
				</template>
				<template v-else-if="userInfo.gender==1">
					<img src="../../assets/images/gender1.jpg" class="portrait" />
				</template>
				<template v-else>
					<img src="../../assets/images/gender3.jpg" class="portrait" />
				</template>
			</div>
			<div class="means_name">
			<p>{{userInfo.name || '-'}}</p>
			<p>会员编号：{{userInfo&&userInfo.memberNo || '未生成会员号'}}</p>
			<p>
				<span v-if="userInfo.memberCategory == 1">会员类型：{{getMemberType(userInfo.memberType) || '网员'}}</span>
				<span v-if="userInfo.memberCategory == 2">会员类型：{{getGroupMemberType(userInfo.memberType) || '网员'}}</span>
				有效期：{{formatTime(userInfo.expiryDate) || '未成为正式会员'}}
			</p>
			</div>
			<!-- van-button round type="danger">成为会员</van-button> -->
		</div>
			<!-- <div class="member_means">
			<dl  @click="go('stationMessage')">
				<dt>{{unReadNum}}</dt>
				<dd>站内信</dd>
			</dl>
			<dl>
				<dt>111</dt>
				<dd>资源共享</dd>
			</dl>
			<dl>
				<dt>111</dt>
				<dd>会员风采</dd>
			</dl>
			</div> -->
		<div class="icon_img">
			<h4>会员服务</h4>
			<van-row>
			<van-col span="6">
				<!-- <div @click="seeMemberInfo()">
					<img src="../../assets/images/user/icon1.jpg">
					<h4>入会申请表</h4>
				</div> -->
				<div @click="go(userInfo.memberCategory===2?'editMember':'member')">
					<img src="../../assets/images/user/icon1.jpg">
					<h4>入会申请表</h4>
				</div>
			</van-col>
			<van-col span="6">
<!--				<div @click="go('MembershipCard')">-->
<!--                <div @click="go('dlxhMembershipCard')">-->
<!--            <div @click="go('TfxqMembershipCard')">-->
<!--            <div @click="go('lbjMembershipCard')">-->
                <div @click="go('wbMembershipCard')">
					<img src="../../assets/images/user/football_name.png">
					<h4>电子会员证</h4>
				</div>
			</van-col>
			<van-col span="6">
				<div @click="go('PaymentList')">
					<img src="../../assets/images/user/liebiao.png">
					<h4>缴费列表</h4>
				</div>
			</van-col>
			<!-- <van-col span="6" >
				<div  @click="go('noticeList')">
					<img src="../../assets/images/user/ai-bind-zy.png">
					<h4>通知公告</h4>
				</div>
			</van-col> -->
			<!-- <van-col span="6" >
				<div  @click="go('resourceSharing')">
					<img src="../../assets/images/user/ai-bind-zy.png">
					<h4>资源共享</h4>
				</div>
			</van-col> -->
					<van-col span="6" >
				<div  @click="go('ChangePassword')">
					<img src="../../assets/images/user/ai-bind-cel.png">
					<h4>修改密码</h4>
				</div>
			</van-col>
			</van-row>
			<van-row>

            <!-- <van-col span="6">
                <div @click="goTip">
                    <img src="../../assets/images/user/ai-bind-fc.png">
                    <h4>会员风采</h4>
                </div>
            </van-col> -->
			<!-- <van-col span="6">
				<div  @click="go('proposalElection')">
					<img src="../../assets/images/user/ai-bind-fk.png">
					<h4>投票选举</h4>
				</div>
			</van-col> -->
			<!-- <van-col span="6" >
				<div  @click="go('ChangePassword')">
					<img src="../../assets/images/user/ai-bind-cel.png">
					<h4>修改密码</h4>
				</div>
			</van-col> -->
			</van-row>
		</div>
		<div class="advcent">
				<van-swipe class="my-swipe" :autoplay="5000" indicator-color="white">
				<van-swipe-item @click="go('feedback')"><img src="../../assets/images/derc.jpg"/></van-swipe-item>
				</van-swipe>
		</div>
   </div>
   <vNavbar :active="navActive" @on_chang_active="changActive"></vNavbar>
  </div>
</template>

<script>
import {
	unRead,
	getUser,
} from "@/api/dictionary";
import vHead from "../../components/header.vue";
import vNavbar from "../../components/navbar.vue";
import {Icon,Row, Col,Button,Swipe,SwipeItem,Dialog,Toast} from 'vant';
import { getSessionStore } from "../../utils/sessionStorage.js";
import { mapGetters, mapState,mapActions} from "vuex";
export default {
  data() {
    return {
    	title:"会员中心",
    	unReadNum:0,
		iconNumber:true,
		userInfo:{},
		navActive:1,
		gender:1,
    };
  },
  components: {
	  vHead,
	  vNavbar,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
	[Button.name]: Button,
	[SwipeItem.name]:SwipeItem,
	[Swipe.name]:Swipe,
    [Dialog.name]:Dialog,
	[Toast.name]:Toast
  },

  methods: {
  	  ...mapActions(["getGroupMemberType", "getPersonMemberType", "getDictionaryList"]),
	  go(pathName) {
		let vider = pathName!='editMember' && pathName!='member' && pathName!='ChangePassword' && pathName!='feedback'
		if(vider){
			let expDate = new Date(this.userInfo.expiryDate);
			let curDate = new Date();
			expDate.setMonth(expDate.getMonth() - 1);
			if (this.userInfo.expiryDate && expDate <= curDate) {
				Dialog.confirm({
					title: '提示',
					message: '您的会员已过期，请您缴纳会费。如已缴费会费，请您耐心等待管理员审核！',
				})
				.then(() => {
					this.$router.push({ name: "PaymentList" });
				})
			return;
			}
		}
		if(!this.userInfo.memberStatus && vider){
			Dialog.alert({
				title: '提示',
				message: '您未成为正式会员，请您完善入会申请表提交并耐心等待管理员审核！',
			}).then(() => {
				if(this.userInfo.memberCategory===2){
					this.$router.push({ name: "editMember" });
				}else{
					this.$router.push({ name: "member" });
				}
			})
			return;
		}
		if(!this.userInfo.memberNo&&vider){
			Dialog.alert({
				title: '提示',
				message: '您未成为正式会员，请您缴纳会费。如已缴费会费，请您耐心等待管理员审核！',
			}).then(() => {
				this.$router.push({ name: "PaymentList" });
			})
			return;
		}
		this.$router.push({ name: pathName});
	  },
	  goTip(){
      		Dialog.alert({
      		message: '该功能暂不支持，请到PC端浏览体验该功能',
      		}).then(() => {
      		// on close
      		});
      	  },
	  formatTime: function(dateUnix){
		  if(!dateUnix)return null;
		  let time = dateUnix.substring(0,10);
		  return time;
	  },
    seeMemberInfo: function(){
          this.$router.push({ name: 'ceshi' });
      },
      unRead(){
          unRead({"memberId":this.memberId}).then(res =>{
              if (res.success) {
                this.unReadNum = res.result;
                if(this.unReadNum==0){
                	this.iconNumber = false;
                }
              }
          })
	  },
	  getGroupMemberType(memberType){
	let group = this.GROUP_TYPE.find(item => item.value === memberType);
    			if(group){
    				return group.name;
    			}else{
    				return "";
    			}
	  },
	  getUserInfo(){
		getUser().then(res=>{
			if (res.success) {
			   	this.userInfo = res.result;
			   	let content = res.result
			     if (typeof content !== 'string') {
					content = JSON.stringify(content);
			  		window.localStorage.setItem("userInfo", content);
				}	
				if(!this.userInfo.memberNo&&!this.userInfo.memberStatus){
					if(this.userInfo.memberCategory===2){
						this.$router.push({ name: "editMember" });
					}else{
						this.$router.push({ name: "member" });
					}
				}
			   	this.gender = res.result.gender;
			}
		})
	  },
	  changActive(val){
  	  	this.navActive = val;
	  }
  },
	computed:{
		// ...mapState(["userInfo"]),
		...mapGetters([ "getMemberType","GROUP_TYPE"])
	},
    mounted() {
     	this.getDictionaryList();
		this.memberId = getSessionStore("memberId");
		this.getPersonMemberType();
		this.unRead();
		this.getUserInfo();
    }
};
</script>
<style lang="less" scoped>
.titde{ overflow: hidden; font-size: 16px; color: #fff; margin-bottom: 25px; padding: 5px 0;}
.titde h4{ float: left;}
.titde span{ float:right;}
.means{ 
	 background:url("../../assets/images/bg_c.jpg");
	 background-size: cover;
	 padding:60px 13px 35px 13px;
	 overflow:hidden;
    .van-button{ float: right; background: #fff; color: #378be1; border:none; line-height: 26px; height: 30px;  margin-top:20px;
		}
}
.artBox{ width: 58px; height: 58px; overflow: hidden;border:#fff solid 2px;border-radius:100%; margin-top:6px;float:left;  }
.portrait{ width:58px; height:58px;  display: block; border-radius: 100%;}
.means_name{float:left; font-size:14px; color:#fff; margin-top:3px;line-height:24px; margin-left:10px;}
.means_name>p:first-of-type{ font-size: 15px;}
.means_name>p,.means_name>p span{ font-size: 13px; color: #fff;}
.means_name>p span{ margin-right: 6px;}
.more{ float:right; margin-top:30px; color:#fff;}
.member_means{ background:#fff; border-radius: 5px;  padding:23px 0; overflow: hidden; margin-top: -10px;}
.member_means dl{ width: 33%; float: left; text-align: center;font-weight: bold; color: #007bff;border-right: #efefef solid 1px;}
.member_means dl dt{ font-size:18px;}
.member_means dl dd{ margin-top: 10px;font-size:14px; font-weight: 100; color: #294073;}
.icon_img{ padding: 15px 10px; font-size:14px; text-align: center; background: #fff; margin-top: 13px; border-radius: 5px;
padding-bottom: 13px;
}
.icon_img>h4{ font-size: 16px; font-weight: 100; text-align: left; padding: 10px 15px; padding-bottom:5px;}
.icon_img img{ width: 55%; display:inline-block; margin-bottom: 10px;}
.van-col{ padding: 15px 0;}
.van-col h4{ position: relative; }
.van-col i{text-align: center;color:#fff; font-weight: bold; background: red; font-size:10px; 
	display:block; position: absolute; right: 20%; width: 14px; height: 14px; border-radius: 50px; line-height: 14px;
	top:-68px; }
.advcent{ margin-top: 15px; padding:16px 15px; background: #fff;}
.my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;

    text-align: center;
	background-color: #39a9ed;
	border-radius: 5px;
  }
  .my-swipe .van-swipe-item img{ width: 100%; border-radius: 5px; display: block;}
</style>
